import styled from "styled-components";
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin-bottom: 0.5em;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  .titulo-label {
    display: flex;
    justify-content: space-between;
  }

  .Label_title_p {
    margin-bottom: 0.25em;
    width: 10em;
  }
`;

export const CardAtividade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0.8em;
  border-radius: 1em;
  background: ${Colors.Color1};
  box-shadow: ${localStorage.getItem("tema") == "E" ? "0px 0px 19px 0px rgb(4 4 4 / 25%)" : "0px 0px 20px rgba(0,0,0,0.07)"} !important;
  width: 18em;
  height: fit-content;
  margin-bottom: 0.7em;
  margin-right: 0.7em;

  .card-atv-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .titulo {
      display: flex;
      flex-direction: row;
      align-items: center;

      .fundo-icon {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 1.40375em;
        height: 1.40375em;
        background: ${Colors.Color8};
        border-radius: 0.4375em;

        .atividade {
          width: 0.95em;
        }
      }

      .item {
        font-size: 0.75em;
        color: ${Colors.Color4};
        font-weight: 700;
        margin-left: 0.5em;
      }
    }

    .icon-button {
      border: none;
      cursor: pointer;
      background: ${Colors.Color1};
      color: ${Colors.Color7};
      font-size: 1.125em;
    }
  }

  .card-atv-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    .padding-left {
      padding: 0;
      padding-left: 0.7em !important;
    }

    .row-top {
      margin-top: 0.5em !important;
    }

    .row {
      width: 100%;
    
      select, input, TextArea {
        width: 100%;
        margin-top: 0.7em;
      }

      .list-analista {
        display: flex;
        flex-direction: column;

        .item-analista {
          margin-top: 0.5em;

          .icon-button {
            border: none;
            cursor: pointer;
            background: ${Colors.Color1};
            color: ${Colors.Color7};
            font-size: 1.125em;
            margin-right: 0.3em;
          }

          .padding-right {
            padding-right: 1em !important;
          }

          .col {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding: 0em;

            p {
              font-size: 0.75em;
              color: ${Colors.Color7};
              font-weight: 500;
              margin-left: 0.5em;
              width: 11em;
            }
          }
        }
      }
    }

    .geraProjeto {
    
      input, TextArea {
        width: 100%;
        margin-top: 0em !important;
      }
    }
  }
`;
